import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';

/* The preview panel shares the samples panel's head, card media, overlays and foot (./SamplesPanel.styles); these are
   only what the batch adds. */

/** The title and, when the batch no longer matches the style, its Outdated tag. */
export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACE[8]};
`;

/** A quiet tag: the samples were drawn from an earlier version of the style (same tone as "Ingredients changed"). */
export const OutdatedTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[4]};
  padding: ${SPACE[2]} ${SPACE[8]};
  border-radius: 999px;
  border: 1px solid ${COLORS.hairline};
  font-size: 11.5px;
  line-height: 1.4;
  color: ${COLORS.accent};

  svg {
    flex: none;
  }
`;

/** "Regenerate samples": keeps its own width beside the copy (full width under it on a phone, as the head stacks). */
export const HeadAction = styled.div`
  flex: none;
`;

/** One notice about the batch (may still be drawing, refused, rating needed, extract again), above the cards. */
export const Notice = styled.div`
  margin-bottom: ${SPACE[16]};
`;

/** The four previews: one format for all of them, so a plain 2 × 2 grid. */
export const PreviewGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${SPACE[12]};
`;

export const PreviewCardRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
  min-width: 0;
`;
